<template>
  <div>
    <template v-if="!refundVoidType">
      <i
        v-if="status.toUpperCase() == 'APPROVED'"
        v-b-tooltip.hover
        title="Approved"
        class="icomoon icon-status-approved text-success disposition"
      ></i>
      <i
        v-b-tooltip.hover
        title="Declined"
        v-if="status.toUpperCase() == 'DECLINED'"
        class="icomoon icon-status-declined text-danger disposition"
      ></i>
    </template>
    <template v-else>
      <i
        v-if="refundVoidType.toUpperCase() == 'REFUNDED'"
        v-b-tooltip.hover
        title="Refunded"
        class="icomoon icon-status-refunded text-warning disposition"
      ></i>
      <i
        v-b-tooltip.hover
        title="Voided"
        v-if="refundVoidType.toUpperCase() == 'VOIDED'"
        class="icomoon icon-status-voided icon-void disposition"
      ></i>
    </template>
  </div>
</template>
<script>
export default {
  name: "disposition",
  props: { status: null, id: null, reason: null, refundVoidType: null },
  data() {
    return {};
  },

  methods: {
    getHover() {
      let t = "Transaction ID : " + this.id.split("-")[0];

      if (this.reason) t = t + ". " + this.reason;

      return t;
    },
    getVariant() {
      if (this.status == "APPROVED") return "success";
      else if (this.status == "DECLINED") return "danger";
    },
  },
};
</script>
<style scoped>
.disposition {
  font-size: 2em !important;
}
</style>
